import { render, staticRenderFns } from "./DocumentObjectModal.vue?vue&type=template&id=6e5f9cb7&scoped=true&"
import script from "./DocumentObjectModal.vue?vue&type=script&lang=js&"
export * from "./DocumentObjectModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentObjectModal.vue?vue&type=style&index=0&id=6e5f9cb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f9cb7",
  null
  
)

export default component.exports